import TriumphDayMixin from '@/mixins/TriumphDayMixin'

export default {
  name: 'Bracket',
  template: '#bracket-template',
  mixins: [TriumphDayMixin],
  data () {
    return {}
  },
  mounted () {
    if (this.$route.path.includes('bracket')) {
      let stepVal = this.$route.path.includes('rewards') ? 2 : 1
      this.$store.dispatch('setVictoryPoints')
      this.$store.dispatch('setLootImg', stepVal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/triumph/Bracket.js